// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

// export const environment = {
//   production: false,
//   apiRoot: 'https://us-central1-backservicespagostest.cloudfunctions.net/webApi/api/v1',
//   query: 'https://us-central1-backservicespagostest.cloudfunctions.net/consultas/api/v1',
//   googleCloudVisionAPIKey: 'AIzaSyDXag6sEj9nYR0Ypg4TVRgqlHENOPiFsZ4'
// };

// export const firebaseConfig = {
//   apiKey: "AIzaSyAs7R3J9a-etcwl9TCUlcyCDIkXGUANJRM",
//   authDomain: "backservicespagostest.firebaseapp.com",
//   databaseURL: "https://backservicespagostest.firebaseio.com",
//   projectId: "backservicespagostest",
//   storageBucket: "backservicespagostest.appspot.com",
//   messagingSenderId: "76008929707",
//   appId: "1:76008929707:web:44272a84ccb8686bcffaee",
//   measurementId: "G-4026WHWS36"
// };

export const environment = {
  production: false,
  apiRoot: 'https://us-central1-backservicespagos.cloudfunctions.net/webApi/api/v1',
  //query: 'https://us-central1-backservicespagos.cloudfunctions.net/consultas/api/v1',
  query: 'https://us-central1-eqpayapp.cloudfunctions.net/apiNewConsul/auth',
  googleCloudVisionAPIKey: 'AIzaSyDXag6sEj9nYR0Ypg4TVRgqlHENOPiFsZ4',

};

export const firebaseConfig = {
  apiKey: "AIzaSyBFkgk7J7J8dzMUE40eWNGcBmkF3MN2SoM",
  authDomain: "backservicespagos.firebaseapp.com",
  databaseURL: "https://backservicespagos.firebaseio.com",
  projectId: "backservicespagos",
  storageBucket: "backservicespagos.appspot.com",
  messagingSenderId: "901254656192",
  appId: "1:901254656192:web:b4ea9046bc05a397753d25",
  measurementId: "G-V8LM1344M3"
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
